import { render, staticRenderFns } from "./score-competition-index.vue?vue&type=template&id=7cc64907&scoped=true"
import script from "./score-competition-index.vue?vue&type=script&setup=true&lang=js"
export * from "./score-competition-index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./score-competition-index.vue?vue&type=style&index=0&id=7cc64907&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc64907",
  null
  
)

export default component.exports